export const TAXABLE = 'T';
export const TAX_FREE = 'O';
export const ZERO_TAX_RATE_CUSTOMS_EXPORT = 'C';
export const ZERO_TAX_RATE_NON_CUSTOMS_EXPORT = 'Z';
